import { NgModule } from '@angular/core';

import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { ViewsRoutingModule } from './views-routing.module';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
@NgModule({
  exports: [I18NextModule],
  imports: [
    CommonModule,
    PageNotFoundModule,
    ViewsRoutingModule,
    I18NextModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule
  ]
})
export class ViewsModule {}
